export const supportedLocales = ['en-CA', 'fr-CA'] as const;

export type ServiceRegistryLocale = (typeof supportedLocales)[number];

export const defaultLocale: ServiceRegistryLocale = 'en-CA';

export const isServiceRegistryLocale = (
  value: unknown,
): value is ServiceRegistryLocale =>
  typeof value === 'string' &&
  supportedLocales.includes(value as ServiceRegistryLocale);
